import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import { Button } from "react-bootstrap";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DatePicker from 'components/sales/datePicker/datePicker';
import moment from 'moment';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import FileUpload from "components/sales/fileUpload/fileUpload";


const B2CEdit = ({
    documentUploadUrlPublic,
    documentUrlDataPublic,
    match,
    bankListRequest,
    bankListResponse = [],
    ucdCaseByIdResponse = [],
    loanApplicationByIdRequest,
    loanApplicationUpdateRequest,
    loanApplicationUpdateResponse = [],
    loanAccountResponse = [],
    loanAccountRequest,
    newBankDetailsRequest,
    newBankDetailsResponse = [],
    vehicleDetailsRequest,
    vehicleDetailsResponse = [],
    updateLoanApplicationForB2C,
    updateb2cloanapplication = [],
    locationPinCode,
    pincodeData = [],
    locationCity,
    cities = [],
    carBrandForB2CRequest,
    carBrandForB2cResponse = [],
    carModelForB2CRequest,
    carModelForB2cResponse = []
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        customer_first_name: '',
        customer_last_name: '',
        phone_number: '',
        pincode: '',
        address: '',
        city: '',
        vehicle_registration_number: '',
        vehicle_brand: '',
        vehicle_model: '',
        vehicle_registration_date: '',
        loan_requested_amount: '',
        loan_tenure: '',
        rate_of_interest: '',
        loan_type: '',
        processing_fees: '',
        bank_name: '',
        meta_data: {
            customer_details: {},
            vehicle_details: {},
            loan_details: {},
            rc_details: {}
        }
    }]);
    const islatlng = useLatLng();
    const [otherBankName, setBankName] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await carBrandForB2CRequest()
            await bankListRequest()
            await newBankDetailsRequest()
            await loanApplicationByIdRequest(match?.params?.id)
            await loanAccountRequest(match?.params?.id)
            await locationCity()
            setIsLoading(false)
        })();
    }, [])

    const handleInput = (val, index, metaDataKey = '', metaIndex = '') => {
        const list = [...inputList]
        if (metaDataKey && metaIndex) {
            list[0]['meta_data'][metaIndex][index] = '';
            list[0]['meta_data'][metaIndex][index] = val
        } else {
            list[0][index] = val
        }

        setInputList(list)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0];
        setIsLoading(true);
        await updateLoanApplicationForB2C(requestParams)
        setIsLoading(false);
    }

    useEffect(() => {
        if (parseInt(updateb2cloanapplication?.status) === 200) {
            toast.success(updateb2cloanapplication?.message);
            setTimeout(() => {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }, 1000)
        } else if (
            updateb2cloanapplication?.status !== 200
        ) {
            toast.warning(updateb2cloanapplication?.message);
        }
    }, [updateb2cloanapplication]);


    const handleFetchModel = async (brandId, brandName) => {
        if (brandId) {
            await carModelForB2CRequest(brandId);
        }
        if(brandName) {
            await carModelForB2CRequest(brandName);
        }
    }

    useEffect(() => {
        if (ucdCaseByIdResponse && ucdCaseByIdResponse?.data) {
            let list = [...inputList];
            let bankList = [];
            newBankDetailsResponse.map(val => {
                bankList.push(val?.name)
            })

            list[0] = {
                meta_data: {
                    loan_application_id: match?.params?.id,
                    status: ucdCaseByIdResponse?.data?.status,
                    customer_details: {
                        customer_first_name: ucdCaseByIdResponse?.data?.customer_details?.customer_first_name ?? "",
                        customer_last_name: ucdCaseByIdResponse?.data?.customer_details?.customer_last_name ?? "",
                        pincode: ucdCaseByIdResponse?.data?.customer_details?.pincode ?? "",
                        phone_number: ucdCaseByIdResponse?.data?.customer_details?.phone_number ?? "",
                        address: ucdCaseByIdResponse?.data?.customer_details?.address ?? "",
                        city: ucdCaseByIdResponse?.data?.customer_details?.city ?? "",
                    },
                    vehicle_details: {
                        vehicle_brand: ucdCaseByIdResponse?.data?.vehicle_details?.vehicle_brand ?? "",
                        vehicle_model: ucdCaseByIdResponse?.data?.vehicle_details?.vehicle_model ?? "",
                        vehicle_registration_number: ucdCaseByIdResponse?.data?.vehicle_details?.vehicle_registration_number ?? "",
                        vehicle_registration_date: ucdCaseByIdResponse?.data?.vehicle_details?.vehicle_registration_date ?? "",
                    },
                    loan_details: {
                        bank_name: ucdCaseByIdResponse?.data?.loan_details?.bank_name ?? "",
                        loan_tenure: ucdCaseByIdResponse?.data?.loan_details?.loan_tenure ?? "",
                        rate_of_interest: ucdCaseByIdResponse?.data?.loan_details?.rate_of_interest ?? "",
                        loan_type: ucdCaseByIdResponse?.data?.loan_details?.loan_type ?? "",
                        disbursal_date: ucdCaseByIdResponse?.data?.loan_details?.disbursal_date ?? "",
                        disbursal_memo: ucdCaseByIdResponse?.data?.loan_details?.disbursal_memo ?? "",
                        processing_fees: ucdCaseByIdResponse?.data?.loan_details?.processing_fees ?? "",
                        loan_requested_amount: ucdCaseByIdResponse?.data?.loan_details?.loan_requested_amount ?? ""
                    },
                    account_details: {
                        account_number: loanAccountResponse?.PRIMARY?.account_number ?? "",
                        ifsc_code: loanAccountResponse?.PRIMARY?.ifsc_code ?? "",
                        bank_name: loanAccountResponse?.PRIMARY?.bank_name ?? "",
                        branch_name: loanAccountResponse?.PRIMARY?.branch_name ?? "",
                        account_id: loanAccountResponse?.PRIMARY?.account_id ?? "",
                    },
                    rc_details: {
                        case_code_by: ucdCaseByIdResponse?.data?.case_code_by ?? "",
                        case_category: ucdCaseByIdResponse?.data?.case_category ?? "",
                        rc_transfer_by: ucdCaseByIdResponse?.data?.rc_transfer_by ?? "",
                    },
                },
            };
            setInputList(list)
        }

        if (ucdCaseByIdResponse?.data?.vehicle_details?.vehicle_brand) {
            handleFetchModel(ucdCaseByIdResponse?.data?.vehicle_details?.vehicle_brand);
        }

    }, [ucdCaseByIdResponse, loanAccountResponse])

    useEffect(() => {
        if (parseInt(loanApplicationUpdateResponse?.status) === 200) {
            setTimeout(() => {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }, 1000)
        } else if (
            loanApplicationUpdateResponse?.status !== 200
        ) {
            toast.error(loanApplicationUpdateResponse?.message);
        }
    }, [loanApplicationUpdateResponse]);


    const pincodeRegex = /^[1-9][0-9]{5}$/;

    const fetchPincodeDetails = async (pincode) => {
        setIsLoading(true);
        try {
            const res = await locationPinCode(pincode);
        } catch (error) {
            console.error("Error fetching pincode details:", error);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (Object.keys(pincodeData).length > 0) {
            setTimeout(async () => {
                handleInput(pincodeData[0]?.city_name, 'city', 'meta_data', 'customer_details')
            }, 100)
        }
    }, [pincodeData]);

    const vehicleRegex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{4}$/;

    const fetchVehicleDetails = async (vehicleNumber) => {
        setIsLoading(true)
        try {
            const response = await vehicleDetailsRequest(vehicleNumber);
        } catch (error) {
            console.error("Error fetching vehicle details:", error);
        }
        setIsLoading(false)
    };

    useEffect(() => {
        if (parseInt(vehicleDetailsResponse?.status) === 200) {
            if (Object.keys(vehicleDetailsResponse.data).length > 0) {
                setTimeout(async () => {
                    handleInput(
                        vehicleDetailsResponse?.data?.brand_name,
                        'vehicle_brand',
                        'meta_data',
                        'vehicle_details'
                    );

                    await handleFetchModel(null, vehicleDetailsResponse?.data?.brand_name);

                    handleInput(
                        vehicleDetailsResponse?.data?.model_name,
                        'vehicle_model',
                        'meta_data',
                        'vehicle_details'
                    );

                    handleInput(
                        vehicleDetailsResponse?.data?.reg_date,
                        'vehicle_registration_date',
                        'meta_data',
                        'vehicle_details'
                    );
                }, 100);
            }
        } else if (vehicleDetailsResponse?.status !== 200) {
            toast.warning(vehicleDetailsResponse?.message);
        }
    }, [vehicleDetailsResponse]);


    const headerBtns = () => {
        return (
            <Button onClick={handleSubmit} className="btn btn-primary">
                {localization.submit}
                <img src={Images?.ArrowRight} alt="" />
            </Button>
        );
    };

    return (
        <>
            <Layout
                title={"Edit Case Details"}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
                {/* customer details section starts */}
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Customer Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={"Customer First Name"}
                                        handleChange={(val) =>
                                            handleInput(val, 'customer_first_name', 'meta_data', 'customer_details')
                                        }
                                        value={inputList[0]['meta_data']?.customer_details?.customer_first_name}
                                        type="text"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={"Customer Last Name"}
                                        handleChange={(val) =>
                                            handleInput(val, 'customer_last_name', 'meta_data', 'customer_details')
                                        }
                                        value={inputList[0]['meta_data']?.customer_details?.customer_last_name}
                                        type="text"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={"Phone Number"}
                                        handleChange={(val) =>
                                            handleInput(val, 'phone_number', 'meta_data', 'customer_details')
                                        }
                                        value={inputList[0]['meta_data']?.customer_details?.phone_number}
                                        type="number"
                                        required={true}
                                        isStarRequired={true}
                                        maxLength={10}
                                        minLength={10}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={"Address"}
                                        handleChange={(val) =>
                                            handleInput(val, 'address', 'meta_data', 'customer_details')
                                        }
                                        value={inputList[0]['meta_data']?.customer_details?.address}
                                        type="text"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={'Pincode'}
                                        handleChange={(val) => {
                                            handleInput(val, 'pincode', 'meta_data', 'customer_details');
                                            // Check validity
                                            if (pincodeRegex.test(val)) {
                                                fetchPincodeDetails(val);
                                            } else {
                                                handleInput("", "city", "meta_data", "customer_details");
                                            }
                                        }}
                                        value={inputList[0]?.meta_data?.customer_details?.pincode}
                                        type="number"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'City'}
                                        data={cities}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'city', 'meta_data', 'customer_details')
                                        }}
                                        value={inputList[0]?.meta_data?.customer_details?.city ?? ""}
                                        isStarRequired={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* customer details section ends */}

                {/* vehicle details section starts */}
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Vehicle Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={'Vehicle Registration Number'}
                                        handleChange={(val) => {
                                            handleInput(val, 'vehicle_registration_number', 'meta_data', 'vehicle_details')
                                            // Check validity
                                            if (vehicleRegex.test(val.toUpperCase())) {
                                                fetchVehicleDetails(val.toUpperCase());
                                            } else {
                                                // invalid or empty → clear brand & model
                                                handleInput('', 'vehicle_model', 'meta_data', 'vehicle_details');
                                                handleInput('', 'vehicle_brand', 'meta_data', 'vehicle_details');
                                                handleInput('', 'vehicle_registration_date', 'meta_data', 'vehicle_details');
                                            }
                                        }}
                                        value={inputList[0]?.meta_data?.vehicle_details?.vehicle_registration_number}
                                        type="text"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'Vehicle Brand'}
                                        data={carBrandForB2cResponse}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'vehicle_brand', 'meta_data', 'vehicle_details')
                                            handleInput('', 'vehicle_model', 'meta_data', 'vehicle_details');
                                            handleFetchModel(val.id)
                                        }}
                                        getValueById={parseInt(inputList[0]?.meta_data?.vehicle_details?.vehicle_brand)}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'Vehicle Model'}
                                        data={carModelForB2cResponse}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'vehicle_model', 'meta_data', 'vehicle_details')
                                        }}
                                        getValueById={parseInt(inputList[0]?.meta_data?.vehicle_details?.vehicle_model)}
                                        isStarRequired={true}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <DatePicker
                                        handleChange={(val) =>
                                            handleInput(val, 'vehicle_registration_date', 'meta_data', 'vehicle_details')
                                        }
                                        label={`Vehicle Registration Date`}
                                        required={false}
                                        value={
                                            inputList[0]?.meta_data?.vehicle_details?.vehicle_registration_date
                                                ? moment(
                                                    inputList[0]?.meta_data?.vehicle_details?.vehicle_registration_date,
                                                    'YYYY-MM-DD'
                                                ).format('DD-MM-YYYY')
                                                : ''
                                        }
                                        isStarRequired={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* vehicle details section ends */}


                {/* loan details section starts */}
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"Loan Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'Bank Name'}
                                        data={bankListResponse}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'bank_name', 'meta_data', 'loan_details')
                                        }}
                                        value={inputList[0]['meta_data']?.loan_details?.bank_name}
                                        isStarRequired={true}
                                        required={true}
                                    />
                                </div>

                                {inputList[0]['bank_name'] === 'Other' &&
                                    <div className="col-md-4">
                                        <ConstantInput
                                            label={'Bank Name'}
                                            handleChange={(val) =>
                                                setBankName(val)
                                            }
                                            value={otherBankName}
                                            type="text"
                                            required={true}
                                            isStarRequired={true}
                                        />
                                    </div>
                                }
                                <div className="col-md-4">
                                    <ConstantInput
                                        label={"Requested Loan amount"}
                                        handleChange={(val) =>
                                            handleInput(val, 'loan_requested_amount', 'meta_data', 'loan_details')
                                        }
                                        value={inputList[0]['meta_data']?.loan_details?.loan_requested_amount}
                                        type="number"
                                        step={'any'}
                                        decimal={'decimal'}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <ConstantInput
                                        label={"Requested Tenure(Months)"}
                                        handleChange={(val) =>
                                            handleInput(val, 'loan_tenure', 'meta_data', 'loan_details')
                                        }
                                        value={inputList[0]['meta_data']?.loan_details?.loan_tenure}
                                        type="number"
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Rate of Interest"}
                                        handleChange={(val) =>
                                            handleInput(val, 'rate_of_interest', 'meta_data', 'loan_details')
                                        }
                                        value={inputList[0]['meta_data']?.loan_details?.rate_of_interest}
                                        type="number"
                                        required={true}
                                        isStarRequired={true}
                                        step={'any'}
                                        decimal={'decimal'}
                                    />
                                </div>

                                <div className="col-sm-4">
                                    <DropDownInput
                                        label={'Loan Type'}
                                        data={[
                                            {
                                                id: "External BT-Topup",
                                                name: "External BT-Topup"
                                            },
                                            {
                                                id: "Internal Topup",
                                                name: "Internal Topup"
                                            },
                                            {
                                                id: "Internal BT",
                                                name: "Internal BT"
                                            },
                                            {
                                                id: "Refinance",
                                                name: "Refinance"
                                            },
                                            {
                                                id: "Purchase",
                                                name: "Purchase"
                                            }
                                        ]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'loan_type', 'meta_data', 'loan_details')
                                        }}
                                        value={inputList[0]['meta_data']?.loan_details?.loan_type}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <ConstantInput
                                        label={"Processing Fees"}
                                        handleChange={(val) =>
                                            handleInput(val, 'processing_fees', 'meta_data', 'loan_details')
                                        }
                                        value={inputList[0]['meta_data']?.loan_details?.processing_fees}
                                        type="number"
                                        step={'any'}
                                        decimal={'decimal'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* loan details section ends */}

                {/* RC details section starts */}
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">{"RC Details"}</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'Case Category'}
                                        data={[
                                            {
                                                id: "CAT_A",
                                                name: "CAT_A"
                                            },
                                            {
                                                id: "CAT_B",
                                                name: "CAT_B"
                                            }
                                        ]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'case_category', 'meta_data', 'rc_details')
                                        }}
                                        value={inputList[0]['meta_data']?.rc_details?.case_category}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'Case Code By'}
                                        data={[
                                            {
                                                id: "Park+",
                                                name: "Park+"
                                            },
                                            {
                                                id: "Other",
                                                name: "Other"
                                            }
                                        ]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'case_code_by', 'meta_data', 'rc_details')
                                        }}
                                        value={inputList[0]['meta_data']?.rc_details?.case_code_by}
                                    />
                                </div>
                                {(inputList[0]['meta_data']?.rc_details?.case_category == "CAT_A") && (
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'RC Transfer By'}
                                        data={[
                                            {
                                                id: "Park+",
                                                name: "Park+"
                                            },
                                            {
                                                id: "Dealer",
                                                name: "Dealer"
                                            },
                                            {
                                                id: "Others",
                                                name: "Others"
                                            }
                                        ]}
                                        getIdValue={(val) => {
                                            handleInput(val.id, 'rc_transfer_by', 'meta_data', 'rc_details')
                                        }}
                                        value={inputList[0]['meta_data']?.rc_details?.rc_transfer_by}
                                    />
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* RC details section ends */}

                {/* account details section starts */}
                {(inputList[0]['meta_data']?.rc_details?.case_category == "CAT_A") && (
                    <>
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">{"Bank Account Details"}</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={"Account Number"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'account_number', 'meta_data', 'account_details')
                                                }
                                                value={inputList[0]['meta_data']?.account_details?.account_number}
                                                type="number"
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={"IFSC Code"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'ifsc_code', 'meta_data', 'account_details')
                                                }
                                                value={inputList[0]['meta_data']?.account_details?.ifsc_code}
                                                type="text"
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <DropDownInput
                                                label={'Bank Name'}
                                                data={bankListResponse}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'bank_name', 'meta_data', 'account_details')
                                                }}
                                                value={inputList[0]['meta_data']?.account_details?.bank_name}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>

                                        {inputList[0]['bank_name'] === 'Other' &&
                                            <div className="col-md-4">
                                                <ConstantInput
                                                    label={'Bank Name'}
                                                    handleChange={(val) =>
                                                        setBankName(val)
                                                    }
                                                    value={otherBankName}
                                                    type="text"
                                                    required={true}
                                                    isStarRequired={true}
                                                />
                                            </div>
                                        }
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={"Branch Name"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'branch_name', 'meta_data', 'account_details')
                                                }
                                                value={inputList[0]['meta_data']?.account_details?.branch_name}
                                                type="text"
                                                isStarRequired={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* disbursal details section ends*/}
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">{"Disbursal Details"}</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <DatePicker
                                                handleChange={(val) =>
                                                    handleInput(val, 'disbursal_date', 'meta_data', 'loan_details')
                                                }
                                                label={`Disbursal Date`}
                                                required={false}
                                                value={
                                                    inputList[0]?.meta_data?.loan_details?.disbursal_date
                                                        ? new Date(inputList[0].meta_data.loan_details.disbursal_date)
                                                        : ''
                                                }
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <FileUpload
                                                id={"addAttachment"}
                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                isStarRequired
                                                required
                                                onChange={(val) =>
                                                    handleInput(val, 'disbursal_memo', 'meta_data', 'loan_details')
                                                }
                                                prefilledFilename={inputList[0]['meta_data']?.loan_details?.disbursal_memo !== "" ? "Attachment 1" : ''}
                                            >
                                                <span className="btn btn-transparent">
                                                    {'Disbursal Memo'}
                                                    <span style={{ color: "red" }}>*</span>
                                                </span>
                                            </FileUpload>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* disbursal details section ends*/}
                    </>
                )}
                {/* account details section ends */}
            </Layout>
        </>
    );
};

export default B2CEdit;
